<template>
	<div class="swipe">
		<swiper :options="swiperOption" >
			<swiper-slide v-for="item in imgArr" :key='item'><img :src="item"/></swiper-slide>
			<div class="swiper-pagination" slot="pagination"></div>
		</swiper>
	</div>	
</template>

<script>
  import config from '@/api/config.js'
  import axios from 'axios';
	import { swiper, swiperSlide } from 'vue-awesome-swiper'
  require("swiper/dist/css/swiper.css");
	const imgArr = [{
		src:'/static/img/home_bg5.png'
	}];
	export default {
		name: 'swipe',
		components: {
			swiper,
			swiperSlide
		},
		data() {
			return {
				swiperOption: {
					pagination: '.swiper-pagination',
					paginationClickable: true,
						autoplay: 5000,
						// height: 911,
						// width: 1920
				},
				imgArr: []
			}
		},
		created() {
			this.getIndexData();
		},
		methods: {
			async getIndexData() {
				try {
					const response = await axios.get(config.baseUrl + '/index/pc');
					this.imgArr = response.data.data.banners;
					console.log(response.data);
				} catch (error) {
					console.error('请求失败:', error);
				}
			},
		},
  }
</script>

<style>
	.swipe {
		left: 0;
		top: 0;
		width: 100%;
		margin: 0;
		padding: 0;
	}
    img {
				width:100%;
				height:100%;
        left: 0px;
    }
</style>



// WEBPACK FOOTER //
// swipe.vue?5bd169f4